export default __webpack_public_path__ + "static/how-it-works-4-8d7266b43eadf883cd49c39b7bed5289.png";